<ng-container *ngIf="section">
  <div
    class="section background-neutral-lightest"
    [class.has-subtitle]="section.subtitle"
    [class.justify-content-start]="section.alignToTop"
  >
    <div
      *ngIf="section.icon.type === 'div'; else fontAwesomeIconTemplate"
      class="feature-illustration m-0"
      [inlineSVG]="section.icon.inlineSVG!"
    ></div>
    <ng-template #fontAwesomeIconTemplate>
      <fa-icon *ngIf="section.icon.fontAwesomeIcon" [icon]="section.icon.fontAwesomeIcon"></fa-icon>
    </ng-template>
    <h3
      aria-level="2"
      class="lh-1 p-0 text-primary text-ultra section-name"
      [id]="section.id"
      [innerHTML]="section.title"
    ></h3>
    <span *ngIf="section.subtitle" class="text-center subtitle fs-1">{{ section.subtitle }}</span>
  </div>
</ng-container>
